<template lang="pug">
div(:class="$style.talkswrapper")
  .c-the-home-chairmantalk
    chairman-box(:photo="chairmanPhoto"
      name="葉進華"
      job="第十五屆理事長"
      homeland="高樹")
    .content.has-text-weight-medium.app-text
      p 各位鄉親、前輩：大家好！
        br
        br
        | 本會成立30週年慶隆重完成，接著又是新年度會務交接，熱鬧非凡。進華有幸在大家的託咐下，承接第15屆理事長，自知能力有限，誠惶誠恐，但要把會務經營好的信念，毅力堅強，勇往直前，絕不退縮，祈請鄉親們給我最大的鼓勵與支持。
        br
        br
        | 一個社團，能持續30年，從不間斷正常的運作，實屬不易，而本會在歷任理事長、幹部及全體會員同心協力下，至今，在桃園市依然有不錯的口碑，並且會員能持續成長，自是大家團結就是力量的展現。
        br
        br
        | 去年30週年慶時，我們以「飛躍三十 齊心公益」捐贈市政府福斯救護車一輛，而本會成立的急難救助基金，經常對面臨困境的屏東鄉親提供即時的資助，這些都是我們發自內心對社會群體的關懷，小額捐款聚沙成塔，這是最真誠最有溫度的行動，因為，我們都來自貧窮，曾經孤苦奮鬥過，最能感同身受，並傳遞“推己及人““助人為快樂之本"的精神，並把善性循環，由外往內昇華，蘊育成本會的特有文化，往後將擴大推行，並爭取更多鄉親的參與認同。人與人之間的互動，是增進相知，相惜最好的方式，本會高樹鄉已辦過一年二次(同屬高樹鄉親)的聚餐，新會員加入不少，效果不錯，明年度擬推廣至各鄉鎮，單獨或2至3鄉鎮聯合辦(地緣相鄰)，增進會務活動的熱絡，對失聯的會員將進行聯絡拜訪，爭取回歸:而在互聯網的時代，年青人是未來的希望，在老一輩逐漸退去後，年輕人有他們的專業、思維、能力，只要給他們舞台，就有機會被看見，承先啟後，創造新局，值得培養、鼓勵。付出是無所求的，我們都在做也在學習;而快樂只要心境轉換，凡事以正向能量思考就可獲得:這方面我旅桃屏東同鄉會已逐步行進，期待營造一個溫馨關懷、情感交流、有歸屬感、被認同的同鄉大家庭，讓我們共同的努力一起完成。
        br
        br
        | 並祝 健康 如意
</template>

<script>
import ChairmanBox from "@/components/ChairmanBox.vue";
import chairmanPhoto from "@/assets/images/chairman.jpg";

export default {
  name: "TheHomeChairmantalk",
  components: {
    ChairmanBox,
  },
  data() {
    return {
      chairmanPhoto,
    };
  },
};
</script>

<style module lang="sass">
.talkswrapper
  padding: 30px
</style>
